import type { Pinia } from 'pinia';
import type { Router } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import type { KioskSeed } from './host-seed';

/* SSO tokenem (osadzenie w pulpicie): jeśli pulpit zaseedował token sesyjny bramy,
   waliduj go przez whoami i zaloguj z zweryfikowanej tożsamości PRZED mountem.
   Brak tokenu -> stary flow (seed firmatic-auth). 401 -> loginWithSsoToken wyloguje.

   Ścieżkę whoami czytamy RAZ, razem z tokenem: oba klucze są wspólne dla originu,
   a jeden origin obsługuje dwie instancje Firmatic (ZKS preprod + produkcja). Token
   bez pasującej ścieżki trafiłby do CUDZEJ bramy, która go nie zna (tokeny są
   in-memory per brama) -> 401 -> wylogowanie. Brak seedu = '/api/whoami' jak dotąd. */
export async function ssoBoot(seed: KioskSeed | null, pinia: Pinia, router: Router): Promise<void> {
  // Seed od hosta (postMessage) ma pierwszenstwo nad localStorage, ktory jest wspolny
  // dla originu i moze pochodzic z karty DRUGIEJ instancji Firmatic.
  const token = seed?.ssoToken ?? localStorage.getItem('firmatic-sso-token');
  if (!token) return;
  const whoami = seed?.whoamiPath ?? localStorage.getItem('firmatic-sso-whoami');
  const auth = useAuthStore(pinia);
  try { await auth.loginWithSsoToken(token, whoami); } catch { /* fallback do seedu */ }

  // Trasę startową guard rozstrzygnął, ZANIM sprawdziliśmy token: app.use(router)
  // rusza z nawigacją od razu, a store miał jeszcze seed firmatic-auth od pulpitu
  // (isLoggedIn: true). Po 401 router sam guardów nie przelicza — montowała się
  // chroniona strona z pustym store'em (sv_numrecuser '' -> „Brak sv_numrecuser",
  // avatar „–"). Przestawiamy trasę przed mountem, więc ta strona nawet nie mignie.
  const route = router.currentRoute.value;
  if (!auth.isLoggedIn && route.meta.requiresAuth) {
    await router.replace({ path: '/login', query: { redirect: route.fullPath } });
  }
}
